import { __assign } from "tslib";
import { composer } from '../../../component-decorators/composer';
import ConfirmSmall from 'wix-ui-icons-common/ConfirmSmall';
import { embeddedScriptAppStatus } from '../../manage-installed-apps-page';
import { Badge, Tooltip, } from 'wix-style-react';
import { canUsePremiumApp, isBundleApp, isBundleAppAndInstalled, isBundleAppAndNotInstalled, isBundleAppFromVoucher, isEmbeddedScriptApp, isNewVersionAvailable, isPendingApp, isSetupIncomplete, } from '../../..';
import React, { useState, useRef } from 'react';
var getNewLabel = function (app, appEmbeddedScriptAppsStatus, t, siteIsPremium, experiments, siteIsBusinessFirstSite) {
    if (isBundleAppAndInstalled(app) && isBundleAppFromVoucher(app)) {
        return t('manage-apps.status.badge.bundle-voucher-installed');
    }
    if (isBundleApp(app)) {
        return t('manage-apps.status.badge.bundle');
    }
    if (!canUsePremiumApp(app, siteIsPremium)) {
        return t('manage-apps.status.badge.premium');
    }
    if (isNewVersionAvailable(app, experiments)) {
        return t('manage-apps.status.badge.update-version');
    }
    if (isPendingApp(app)) {
        if (siteIsBusinessFirstSite) {
            return t('manage-apps.status.badge.site-pending');
        }
        return t('manage-apps.status.badge.Pending');
    }
    if (isSetupIncomplete(app, experiments)) {
        return t('manage-apps.status.badge.incomplete-setup');
    }
    if (isEmbeddedScriptApp(app)) {
        switch (appEmbeddedScriptAppsStatus) {
            case embeddedScriptAppStatus.ENABLED:
                return t('manage-apps.status.badge.running');
            default:
                return t('manage-apps.status.badge.Paused');
        }
    }
};
var getLabel = function (app, appEmbeddedScriptAppsStatus, t, siteIsPremium, experiments, siteIsBusinessFirstSite) {
    if (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.complete-setup')) {
        return getNewLabel(app, appEmbeddedScriptAppsStatus, t, siteIsPremium, experiments, siteIsBusinessFirstSite);
    }
    if (isBundleAppAndInstalled(app) && isBundleAppFromVoucher(app)) {
        return t('manage-apps.status.badge.bundle-voucher-installed');
    }
    if (isBundleApp(app)) {
        return t('manage-apps.status.badge.bundle');
    }
    if (!canUsePremiumApp(app, siteIsPremium)) {
        return t('manage-apps.status.badge.premium');
    }
    if (isNewVersionAvailable(app, experiments)) {
        return t('manage-apps.status.badge.update-version');
    }
    if (isPendingApp(app)) {
        if (siteIsBusinessFirstSite) {
            return t('manage-apps.status.badge.site-pending');
        }
        return t('manage-apps.status.badge.Pending');
    }
    if (isEmbeddedScriptApp(app)) {
        switch (appEmbeddedScriptAppsStatus) {
            case embeddedScriptAppStatus.ENABLED:
                return t('manage-apps.status.badge.running');
            default:
                return t('manage-apps.status.badge.Paused');
        }
    }
};
var getTheme = function (app, appEmbeddedScriptAppsStatus, siteIsPremium, experiments) {
    if (isBundleApp(app)) {
        return {
            skin: 'success',
            type: 'solid',
            size: 'small',
            uppercase: false,
        };
    }
    if (!canUsePremiumApp(app, siteIsPremium)) {
        return {
            skin: 'neutralDanger',
            type: 'solid',
            size: 'small',
            uppercase: false,
        };
    }
    if (isPendingApp(app) ||
        isNewVersionAvailable(app, experiments) ||
        isSetupIncomplete(app, experiments)) {
        return {
            skin: 'neutralLight',
            type: 'outlined',
            size: 'small',
            uppercase: false,
        };
    }
    if (isEmbeddedScriptApp(app)) {
        switch (appEmbeddedScriptAppsStatus) {
            case embeddedScriptAppStatus.ENABLED:
                return {
                    skin: 'success',
                    type: 'outlined',
                    size: 'small',
                    uppercase: false,
                    prefixIcon: React.createElement(ConfirmSmall, null),
                };
            default:
                return {
                    skin: 'neutralDanger',
                    type: 'outlined',
                    size: 'small',
                    uppercase: false,
                };
        }
    }
};
var shouldShowBadge = function (app, appEmbeddedScriptAppsStatus, siteIsPremium, experiments) {
    if (!canUsePremiumApp(app, siteIsPremium)) {
        return true;
    }
    if (isPendingApp(app) || isBundleApp(app)) {
        return true;
    }
    if (isNewVersionAvailable(app, experiments)) {
        return true;
    }
    if (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.complete-setup')) {
        return isSetupIncomplete(app, experiments);
    }
    if (isEmbeddedScriptApp(app)) {
        return (appEmbeddedScriptAppsStatus &&
            appEmbeddedScriptAppsStatus === embeddedScriptAppStatus.DISABLED);
    }
    return false;
};
var shouldShowTooltip = function (app, appEmbeddedScriptAppsStatus, siteIsPremium, experiments) {
    if (!canUsePremiumApp(app, siteIsPremium)) {
        return true;
    }
    if (isPendingApp(app) || isBundleApp(app)) {
        return true;
    }
    if (isNewVersionAvailable(app, experiments)) {
        return true;
    }
    if (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.complete-setup')) {
        return isSetupIncomplete(app, experiments);
    }
    return false;
};
var getTooltipContent = function (app, appEmbeddedScriptAppsStatus, t, siteIsPremium, experiments, siteIsBusinessFirstSite) {
    if (isBundleAppAndNotInstalled(app) && isBundleAppFromVoucher(app)) {
        return t('manage-apps.status.badge.tooltip-bundle-voucher-not-installed', {
            appName: app.webSolutionBase.name,
        });
    }
    if (isBundleAppAndNotInstalled(app)) {
        return t('manage-apps.status.badge.tooltip-bundle-not-installed', {
            appName: app.webSolutionBase.name,
        });
    }
    if (isBundleAppAndInstalled(app) && isBundleAppFromVoucher(app)) {
        return t('manage-apps.status.badge.tooltip-bundle-installed-voucher', {
            appName: app.webSolutionBase.name,
        });
    }
    if (isBundleAppAndInstalled(app)) {
        return t('manage-apps.status.badge.tooltip-bundle-installed', {
            appName: app.webSolutionBase.name,
        });
    }
    if (!canUsePremiumApp(app, siteIsPremium)) {
        return t('manage-apps.status.badge.tooltip-premium');
    }
    if (isNewVersionAvailable(app, experiments)) {
        return t('manage-apps.status.badge.tooltip-update-version');
    }
    if (isPendingApp(app)) {
        if (siteIsBusinessFirstSite) {
            return t('manage-apps.status.badge.tooltip-site-pending');
        }
        return t('manage-apps.status.badge.tooltip-pending');
    }
    if ((experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.complete-setup')) &&
        isSetupIncomplete(app, experiments)) {
        return t('manage-apps.status.badge.tooltip-complete-setup');
    }
    if (isEmbeddedScriptApp(app)) {
        return t('manage-apps.status.badge.tooltip-missing', {
            appName: app.webSolutionBase.name,
        });
    }
};
var AppBadgeBase = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var t = _a.t, app = _a.app, appEmbeddedScriptAppsStatus = _a.appEmbeddedScriptAppsStatus, siteIsPremium = _a.siteIsPremium, experiments = _a.experiments, siteIsBusinessFirstSite = _a.siteIsBusinessFirstSite;
    return (React.createElement(Badge, __assign({}, getTheme(app, appEmbeddedScriptAppsStatus, siteIsPremium, experiments)), getLabel(app, appEmbeddedScriptAppsStatus, t, siteIsPremium, experiments, siteIsBusinessFirstSite)));
});
export var AppBadge = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var t = _a.t, app = _a.app, appEmbeddedScriptAppsStatus = _a.appEmbeddedScriptAppsStatus, siteIsPremium = _a.siteIsPremium, siteIsBusinessFirstSite = _a.siteIsBusinessFirstSite, experiments = _a.experiments;
    var _b = useState(shouldShowBadge(app, appEmbeddedScriptAppsStatus, siteIsPremium, experiments)), show = _b[0], setShow = _b[1];
    var updateTimer = useRef(null);
    var firstRender = useRef(true);
    function setUpdate() {
        setShow(!firstRender.current);
        updateTimer.current = setTimeout(function () {
            setShow(false);
            updateTimer.current = null;
        }, 2000);
    }
    React.useEffect(function () {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        if (!updateTimer.current &&
            appEmbeddedScriptAppsStatus === embeddedScriptAppStatus.ENABLED) {
            setUpdate();
        }
        else {
            setShow(true);
        }
    }, [appEmbeddedScriptAppsStatus]);
    React.useEffect(function () {
        return function () {
            if (updateTimer.current) {
                clearTimeout(updateTimer.current);
            }
        };
    }, []);
    return show ? (shouldShowTooltip(app, appEmbeddedScriptAppsStatus, siteIsPremium, experiments) ? (React.createElement(Tooltip, { appendTo: "scrollParent", maxWidth: 224, content: getTooltipContent(app, appEmbeddedScriptAppsStatus, t, siteIsPremium, experiments, siteIsBusinessFirstSite) },
        React.createElement(AppBadgeBase, { t: t, app: app, appEmbeddedScriptAppsStatus: appEmbeddedScriptAppsStatus, siteIsPremium: siteIsPremium, siteIsBusinessFirstSite: siteIsBusinessFirstSite }))) : (React.createElement(AppBadgeBase, { t: t, app: app, appEmbeddedScriptAppsStatus: appEmbeddedScriptAppsStatus, siteIsPremium: siteIsPremium, siteIsBusinessFirstSite: siteIsBusinessFirstSite }))) : (React.createElement("div", null));
});
//# sourceMappingURL=app-badge.js.map